(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  root.SalutCheckoutPayload = api;
})(typeof window !== 'undefined' ? window : globalThis, function () {
  function round2(n) { return Math.round(n * 100) / 100; }

  var CODE = 'discount_code';

  function bucketDiscounts(cart) {
    var byKey = {};
    function add(title, type, amountCents) {
      var name = title || 'Discount';
      var kind = type === CODE ? CODE : 'automatic';
      var key = kind + ' ' + name;
      if (!byKey[key]) byKey[key] = { name: name, type: kind, amountCents: 0 };
      byKey[key].amountCents += amountCents;
    }
    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (alloc) {
        var app = alloc.discount_application || {};
        add(app.title, app.type, alloc.amount);
      });
    });
    (cart.cart_level_discount_applications || []).forEach(function (app) {
      add(app.title, app.type, app.total_allocated_amount);
    });
    var buckets = Object.keys(byKey).map(function (k) { return byKey[k]; });
    var sentCents = buckets.reduce(function (s, b) { return s + b.amountCents; }, 0);
    var totalDiscountCents = typeof cart.total_discount === 'number' ? cart.total_discount : (cart.total_discounts || 0);
    return {
      buckets: buckets,
      sentMdl: round2(sentCents / 100),
      leftoverCents: totalDiscountCents - sentCents,
    };
  }

  function buildDiscountCodes(cart) {
    return bucketDiscounts(cart).buckets
      .filter(function (b) { return b.type === CODE; })
      .map(function (b) { return { code: b.name }; });
  }

  function buildAutomaticDiscounts(cart) {
    return bucketDiscounts(cart).buckets
      .filter(function (b) { return b.type !== CODE; })
      .map(function (b) { return { title: b.name }; });
  }

  function buildDiscountDisplay(cart) {
    return bucketDiscounts(cart).buckets.map(function (b) {
      return { name: b.name, amount: round2(b.amountCents / 100) };
    });
  }

  function buildPayload(cart, form, shipping) {
    return {
      amount: round2(cart.total_price / 100 + shipping.deliveryMdl),
      currency: cart.currency || 'MDL',
      description: (cart.items || []).map(function (i) { return i.quantity + 'x ' + i.title; }).join(', '),
      customerName: form.customerName,
      email: form.email,
      phone: form.phone,
      address1: form.address1,
      address2: form.address2 || '',
      city: form.city,
      province: form.province || '',
      zip: form.zip || '',
      country: form.country,
      country_code: form.country_code,
      buyer_accepts_marketing: !!form.buyer_accepts_marketing,
      paymentType: form.paymentType,
      delivery: round2(shipping.deliveryMdl),
      shippingTitle: shipping.shippingTitle,
      products: (cart.items || []).map(function (i) {
        return { variant_id: i.variant_id, quantity: i.quantity, price: round2(i.original_price / 100) };
      }),
      items: (cart.items || []).map(function (i) {
        return { title: i.title, quantity: i.quantity, amount: round2(i.original_price / 100) };
      }),
      discount_codes: buildDiscountCodes(cart),
      automatic_discounts: buildAutomaticDiscounts(cart),
    };
  }

  function verifyPayload(payload, cart) {
    var errors = [];
    var catalogTotal = (cart.items || []).reduce(function (s, i) { return s + i.original_price * i.quantity; }, 0) / 100;
    var b = bucketDiscounts(cart);
    var discounts = b.sentMdl;
    var reconstructed = round2(catalogTotal + payload.delivery - discounts);
    if (Math.abs(reconstructed - payload.amount) > 0.011) {
      errors.push('Invariant picat: catalog ' + round2(catalogTotal) + ' + delivery ' + payload.delivery + ' - discounturi ' + round2(discounts) + ' = ' + reconstructed + ' != amount ' + payload.amount);
    }
    var displayed = round2(cart.total_price / 100 + payload.delivery);
    if (Math.abs(displayed - payload.amount) > 0.011) {
      errors.push('amount ' + payload.amount + ' difera de totalul afisat clientului ' + displayed);
    }
    if (b.leftoverCents !== 0) {
      errors.push('Discount netratat (conservarea numerelor): ' + b.leftoverCents + ' cents din cart.total_discount nu au galeata');
    }
    if (payload.amount <= 0) {
      errors.push('Suma de plata este zero — comanda nu poate fi trimisa online');
    }
    var declared = (payload.discount_codes || []).length + (payload.automatic_discounts || []).length;
    if (declared !== b.buckets.length) {
      errors.push('Conservarea numerelor: ' + b.buckets.length + ' reduceri in cos, ' + declared + ' declarate in payload');
    }
    return { ok: errors.length === 0, errors: errors };
  }

  return {
    round2: round2,
    bucketDiscounts: bucketDiscounts,
    buildDiscountCodes: buildDiscountCodes,
    buildAutomaticDiscounts: buildAutomaticDiscounts,
    buildDiscountDisplay: buildDiscountDisplay,
    buildPayload: buildPayload,
    verifyPayload: verifyPayload,
  };
});
